<template>
  <div class="z-card">
    <div v-if="titleparam.title" class="z-card-head">
      <div class="z-title">
        <svg-icon
          style="vertical-align: middle; fill: #006fcc"
          :className="titleparam.iconclass"
          :icon-class="titleparam.iconname"
        />
        <span style="margin-left: 6px; vertical-align: middle">{{
          titleparam.title
        }}</span>
      </div>
      <div v-if="btngroup" class="z-button-group">
        <!-- <a-radio-group v-model="btnactive" style="margin: 8px">
          <a-radio-button @click="groupbtnclick(item.key, item)" v-for="item in btngroup" :key="item.key"> {{ item.name }} </a-radio-button>

        </a-radio-group> -->
        <button
          v-for="item in btngroup"
          :key="item.key"
          @click="groupbtnclick(item.key, item)"
          :class="btnactive == item.key ? 'z-button-checked' : ''"
        >
          {{ item.name }}
        </button>
      </div>
      <div v-if="tabgroup.length>0&&titleparam.morelink" class="z-card-tab">
        <a-tabs default-active-key="1" style="display: inline-block;margin-left: 0px;height: 50px;" @change="tabchange">
          <a-tab-pane v-for="item of tabgroup" :key="item.key" :tab="item.name"></a-tab-pane>
        </a-tabs>
        <div v-if="titleparam.morelink" class="z-card-more" style="margin-left: 10px;font-size: 12px;">
          <router-link :to="titleparam.morelink"
            >查看更多 <svg-icon className="" icon-class="right" style="width: 14px;"
          /></router-link>
        </div>
      </div>
      <div v-else-if="titleparam.morelink" class="z-card-more">
        <router-link :to="titleparam.morelink"
          >查看更多 <svg-icon className="" icon-class="right"
        /></router-link>
      </div>
      <div v-if="titleparam.dzdc" class="z-card-more" style="color:#bfbfbf;">
        共计：<span style="color:black;">{{titleparam.dzdc}}</span>
      </div>
    </div>
    <div class="z-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "z-card",
  props: {
    titleparam: {
      type: Object,
      default() {
        return {
          iconclass: "",
          title: "",
          iconname: "",
          morelink: "",
          dzdc:"",
        };
      },
    },
    btngroup: {
      type: Array,
      default() {
        return [];
      },
    },
    tabgroup: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      btnactive: "",
    };
  },
  created() {},
  mounted() {
    console.log(this.btngroup);
    
    this.btngroup.filter((a) => {
      if (a.active) {
        this.btnactive = a.key;
      }
    });
  },
  methods: {
    groupbtnclick(key, item) {
      this.btnactive = key;
      this.$emit("cardbtncallback", key, item);
    },
    tabchange(key) {
      this.$emit("cardbtncallback", key);
    },
  },
};
</script>

<style scoped lang="less">
// .z-card{
//   .z-title {
//     width: 104px;
//     border-top: 5px solid #ff4d4f;
//     line-height: 48px;
//     float: left;
//   }
//   .z-button-group {
//     margin-top: 12px;
//     margin-left: 48px;
//     float: left;
//     button {
//       height: 32px;
//       border-radius: 2px;
//       border: none;
//       color: #595959;
//       cursor: pointer;
//       font-size: 14px;
//       padding: 0 16px;
//       background: #f0f0f0;
//     }
//     button:hover {
//       color: #fff;
//       color: #f5222d;
//       background: #ff7875;
//       // background: #ff4d4f;
//       background: #fff1f0;
//     }
//     button:active {
//       color: #fff;
//       background: #f5222d;
//       background: #ff4d4f;
//     }
//     button:not(:first-child) {
//       margin-left: 8px;
//     }
//     .z-button-checked {
//       font-weight: 600;
//       color: #fff;
//       background: #ff4d4f;
//       background: linear-gradient(15deg, #ff4d4f 0%, #ff7875 100%);
//     }
//     .z-button-checked:hover {
//       color: #fff;
//       background: #ff4d4f;
//     }
//   }

//   .z-card-more {
//     float: right;
//     line-height: 56px;
//     font-size: 14px;
//     font-weight: 400;
//     a {
//       color: #bfbfbf;
//     }
//     svg {
//       width: 18px;
//       vertical-align: middle;
//       margin-left: -8px;
//       margin-top: -2px;
//     }
//   }
//   .z-card-more:hover {
//     a {
//       color: #f5222d;
//     }
//   }
// }
</style>
